import { JSX } from "@emotion/react/jsx-runtime";
import { ReactNode } from "react";
import { Typography } from "@mui/material";
import { DynamicContentImage } from "../DynamicContentComponent";
import { ImageComponent } from "../ImageComponent";

export const DynamicImage = ({ imageSrc, imageProps, variant, key, childElements }: DynamicContentImage): JSX.Element => {
    if (variant) {
      return (
        <ImageComponent 
          variant={variant}
          imageSrc={imageSrc}
          imageProps={imageProps}
          key={key}
        >
          {childElements || ''}
        </ImageComponent>  
      )
    }
    return (
      <ImageComponent
        imageSrc={imageSrc}
        imageProps={imageProps}
        key={key}
      >
        {childElements || ''}
      </ImageComponent> 
    )
}